module.exports = __webpack_public_path__ + "static/media/background.5be1c118.png";